import React from 'react';
import { IconType } from 'react-icons';
import { Button, Modal } from 'rsuite';
import searchStatsIcon from '../../assets/icons/icon_search_stats.svg';
import styles from './ModalSpeakWithSpecialist.module.scss';

export type ModalSpeakWithSpecialistFeature = {
  icon: IconType;
  title: string;
  description: string;
};

type ModalSpeakWithSpecialistProps = {
  show: boolean;
  title: string;
  subtitle: string;
  icon?: string;
  secondaryTitle?: string;
  features?: ModalSpeakWithSpecialistFeature[];
  actionLabel?: string;
  style?: React.CSSProperties;
  onClick: () => void;
  onCancel: () => void;
};

export const ModalSpeakWithSpecialist = ({
  show,
  title,
  subtitle,
  icon = searchStatsIcon,
  secondaryTitle,
  features,
  actionLabel = 'Fale com um especialista',
  style,
  onClick,
  onCancel,
}: ModalSpeakWithSpecialistProps) => {
  return (
    <Modal show={show} size="md" className={styles['modal-speak-with-specialist']} style={style}>
      <Modal.Header onHide={onCancel} />
      <Modal.Body className={styles.content}>
        <div className={styles['icon-container']}>
          <img src={icon} className={styles.icon} />
        </div>
        <h6 className={styles.title}>{title}</h6>
        <p className={styles.subtitle}>{subtitle}</p>
        {secondaryTitle && <h6 className={styles['secondary-title']}>{secondaryTitle}</h6>}
        {features && features.length > 0 && (
          <div className={styles.features}>
            {features.map(feature => (
              <div key={feature.title} className={styles.featureCard}>
                <div className={styles.featureIcon}>
                  <feature.icon size={20} />
                </div>
                <p className={styles.featureTitle}>{feature.title}</p>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className={styles.footer}>
        <Button appearance="subtle" className={styles['btn-cancel']} onClick={onCancel}>
          Cancelar
        </Button>
        <Button id="upsell" appearance="primary" className={[styles['btn-action'], 'upsell'].join(' ')} onClick={onClick}>
          {actionLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
